module.exports = __webpack_public_path__ + "img/h29.117f7042.png";